import { Link } from 'react-router-dom';

function PageNotFound() {
    return (
        <main className='Main'>
            <h2>Page Not Found</h2>
            <p>
                <Link to='/'>Visit Our Homepage</Link>
            </p>
        </main>
    )
}

export default PageNotFound